import Vue from "vue";
import axios from "axios";
import { MessageBox, Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// const zjService = axios.create({
//   baseURL: baseURL,
//   timeout: 50000
// })

// zjService.interceptors.request.use(
//   // 每次请求都自动携带Cookie
//   config => {
//     // config.headers.wflowToken = localStorage.getItem('wflow-token')
//     config.headers.token = sessionStorage.getItem('token') || 'e89d65aa19329e304b33e61de2d279e8'
//     config.headers.customer = localStorage.getItem('customer') || 'zuhu'
//     return config;
//   },
//   // eslint-disable-next-line handle-callback-err
//   error => {
//     return Promise.reject(error);
//   }
// );
// // 添加响应拦截器
// zjService.interceptors.response.use(res => {
//   if (res.status !== 200) {
//     Message({ type: 'error', message: '数据加载失败，请稍后再试' })
//     return Promise.reject(new Error(res.data))
//   }
//   if (Object.prototype.toString.call(res.data) !== '[object Object]') {
//     Message({ type: 'error', message: '返回数据异常' })
//     return Promise.reject(new Error(res.data))
//   }
//   if (res.data.code === 200) {
//     return res.data
//   } else if (res.data.code === 100000) { // 可能token失效或者refreshToken失效
//     Message({ type: 'error', message: '登录失效，请重新登录' })
//     const pLocation = window.parent.location
//     pLocation.href = pLocation.origin + pLocation.pathname + '#/login'
//     return Promise.reject(res.data)
//   } else {
//     Message({ type: 'error', message: res.data.message || '出现异常' })
//     return Promise.reject(new Error(res.data.message))
//   }
// }, function (error) {
//   return Promise.reject(error)
// })
// Vue.prototype.$axios = zjService;
const baseURL = Vue.prototype.BASE_URL;
const service = axios.create({
  baseURL: baseURL,
  timeout: 50000
});

service.defaults.withCredentials = true; // 让ajax携带cookie
service.interceptors.request.use(config => {
  if (config.url.startsWith('/business')) { // business开头的不需要添加wflow目录
    config.baseURL = ''
  }
  // config.headers.wflowToken = localStorage.getItem('wflow-token')
  config.headers.token = sessionStorage.getItem('token') || 'e89d65aa19329e304b33e61de2d279e8'
  config.headers.customer = localStorage.getItem('customer') || 'zuhu'
  return config;
}, error => {
  return Promise.reject(error);
})

service.interceptors.response.use(
  rsp => {

    return rsp;
  },
  // 拦截异常的响应
  err => {
    switch (err.response.status) {
      case 401:
        MessageBox.alert("登陆失效，请点击右上角头像重新切换人员");
        break;
      case 403:
        Message.warning("抱歉，您无权访问！")
        break;
      case 500:
        break;
      case 404:
        break;
      default:
        //throw 'request error'
        return Promise.reject(err);
    }
    //throw 'request error'
    return Promise.reject(err);
  }
);

export function syncRequest (config) {
  let ajax = new XMLHttpRequest();
  ajax.withCredentials = true
  //ajax.responseType = 'json'
  ajax.open(config.method, baseURL + config.url, false);
  ajax.onload = function (e) {
    if (ajax.readyState === 4) {
      if (ajax.status === 200 && config.success) {
        config.success(ajax.responseText)
      } else if (config.fail) {
        config.fail(ajax.responseText)
      }
    }
  };
  ajax.onerror = function (e) {
    if (config.fail) {
      config.fail(ajax.responseText)
    }
  }
  if (config.data) {
    if (config.type === 'json') {
      ajax.setRequestHeader("Content-type", "application/json");
      ajax.send(JSON.stringify(config.data))
    } else {
      ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      let form = new FormData()
      for (const key in config.data) {
        form.set(key, config.data[key])
      }
      ajax.send(form)
    }
  } else {
    ajax.send(null)
  }
}

export default service;
